import {getPath} from "../../../../shared/utils";
import {paths, queryParams} from "../../../../shared/routing";
import {Tier} from "~services/business/pricing/tier";
import {Mode} from "~services/business/pricing/mode";
import {Country} from "~services/i18n/country";
import {NextRouter} from "next/router";

/**
 * get URL with query params to "sign up" page for merchants
 */
export function getSignUpLink(country: Country, tierName?: Tier, tierMode?: Mode): string {
    let output = getPath(paths.join_us, country);

    // set default if not specified
    let ownTierName = tierName;
    if (null === tierName) {
        ownTierName = Tier.START;
    }

    // set default if not specified
    let ownTierMode = tierMode;
    if (null === tierMode) {
        ownTierMode = Mode.MONTHLY;
    }

    output += `?${queryParams.join_us.tier_name}=${ownTierName}`;
    output += `&${queryParams.join_us.tier_mode}=${ownTierMode}`;

    return output;
}

// todo: how to use these names from "queryParams" object instead of referring them here again?
type PricingQueryParams = {
    tierName: null | string,
    tierMode: null | string,
}

/**
 * get data from query params in the form
 */
export function getPricingQueryParams(router: NextRouter): PricingQueryParams {
    return {
        tierMode: router.query.tierMode?.toString(),
        tierName: router.query.tierName?.toString(),
    }
}
